import { REPLY_EDITOR_MODES } from "dashboard/components/widgets/WootWriter/constants";
import { LocalStorage } from "shared/helpers/localStorage";

const PILOT_EMAIL = "app@yourhousingperks.com";
const AI_DRAFT_BCC = "support@yourhousingperks.com";
const SUPPORT_EMAILS = [PILOT_EMAIL, AI_DRAFT_BCC];

export function addPilotDraftBcc(editor) {
  if (
    !SUPPORT_EMAILS.includes(editor.inbox?.email) ||
    editor.effectiveReplyMode !== REPLY_EDITOR_MODES.REPLY ||
    editor.isPrivate ||
    !editor.message.trim() ||
    !editor.loadedPilotDrafts[editor.getDraftKey()]
  ) {
    return;
  }

  const recipients = (editor.bccEmails || "")
    .split(",")
    .map((email) => email.trim())
    .filter((email) => email && email.toLowerCase() !== PILOT_EMAIL);
  if (!recipients.some((email) => email.toLowerCase() === AI_DRAFT_BCC)) {
    recipients.push(AI_DRAFT_BCC);
  }
  editor.bccEmails = recipients.join(", ");
}

export async function loadPilotDraft(editor, api) {
  const request = ++editor.pilotDraftRequest;
  const conversationId = editor.conversationIdByRoute;
  const sourceId = Number(editor.pilotDraftSourceId);
  const key = editor.getDraftKey();
  const previous = editor.loadedPilotDrafts[key];
  addPilotDraftBcc(editor);

  const canLoad = () =>
    SUPPORT_EMAILS.includes(editor.inbox?.email) &&
    editor.effectiveReplyMode === REPLY_EDITOR_MODES.REPLY &&
    !editor.isPrivate &&
    !editor.isEditorDisabled &&
    !editor.copilot.isActive.value &&
    !editor.attachedFiles.length &&
    (!editor.hasMeaningfulEditorContent ||
      (previous && editor.message === previous.message));

  if (!conversationId || !sourceId || !canLoad()) return;
  if (previous && sourceId <= previous.sourceId) return;

  const originalMessage = editor.message;
  try {
    const { data } = await api.getDraft(conversationId);
    // Ignore delayed responses after navigation, typing, mode changes, or a newer customer message.
    if (
      request !== editor.pilotDraftRequest ||
      conversationId !== editor.conversationIdByRoute ||
      sourceId !== Number(editor.pilotDraftSourceId) ||
      originalMessage !== editor.message ||
      !canLoad() ||
      !data.has_draft ||
      Number(data.ai_draft?.source_message_id) !== sourceId ||
      typeof data.message !== "string" ||
      !data.message.trim() ||
      data.message.length > editor.maxLength
    ) {
      return;
    }

    editor.message = editor.toggleSignatureForDraft(data.message);
    editor.loadedPilotDrafts[key] = { sourceId, message: editor.message };
    LocalStorage.set(
      "housing-perks-ai-draft-origins",
      editor.loadedPilotDrafts,
    );
    addPilotDraftBcc(editor);
    editor.saveDraft(conversationId, REPLY_EDITOR_MODES.REPLY);
  } catch {
    // A missing/unavailable draft must never interfere with an agent's local draft.
  }
}
